import { render } from "./deliveredorderSvg.vue?vue&type=template&id=b0ed89aa"
import script from "./deliveredorderSvg.vue?vue&type=script&lang=js"
export * from "./deliveredorderSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__